import { NewMarkDisplayMode, NewMarkType } from '@intelligence/enums/common';

import type { INewMarkCfg } from '@intelligence/types/newMark';

// 静态New标签、Beta标签配置（目前仅包含Tab、小红点，菜单的New标签、Beta标签配置从菜单接口返回数据生成）
export const STATIC_NEW_MARK_CFG: Record<string, INewMarkCfg> = {
  // tab00061: {
  //   newMarkDisplayMode: NewMarkDisplayMode.Fixed,
  //   newMarkType: NewMarkType.New,
  // },
  // tab00165: {
  //   newMarkDisplayMode: NewMarkDisplayMode.Fixed,
  //   newMarkType: NewMarkType.New,
  // },
  // TopChartsMobileGamesDemographics
  tab00006: {
    newMarkDisplayMode: NewMarkDisplayMode.Fixed,
    newMarkType: NewMarkType.New,
  },
  // Mobile详情页Stats(数据)页签
  tab00462: {
    newMarkDisplayMode: NewMarkDisplayMode.Fixed,
    newMarkType: NewMarkType.New,
  },
  // Mobile详情页Demographics页签
  tab00466: {
    newMarkDisplayMode: NewMarkDisplayMode.Fixed,
    newMarkType: NewMarkType.New,
  },
  // Mobile详情页Overlap页签
  tab00467: {
    newMarkDisplayMode: NewMarkDisplayMode.Fixed,
    newMarkType: NewMarkType.New,
  },
  /** tab的New标签、Beta标签配置 **/
  // PCGamesDetailsOverlap
  tab00487: {
    newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
    newMarkType: NewMarkType.New,
  },
  // PCConsoleGamesDetailsOverview
  // tab00521: {
  //   newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
  //   newMarkType: NewMarkType.New,
  // },
  // PCConsoleGamesDetailsOverlap
  tab00527: {
    newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
    newMarkType: NewMarkType.New,
  },
  // PCConsoleGamesDetailsGameInfo
  // tab00528: {
  //   newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
  //   newMarkType: NewMarkType.New,
  // },
  // PCConsoleGamesDetailsKPITrends
  // tab00529: {
  //   newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
  //   newMarkType: NewMarkType.New,
  // },
  // PCConsoleGamesDetailsCountries
  tab00530: {
    newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
    newMarkType: NewMarkType.Beta,
  },
  tab601: {
    newMarkDisplayMode: NewMarkDisplayMode.Fixed,
    newMarkType: NewMarkType.New,
  },
  /** tab的New标签、Beta标签配置 **/

  /** 小红点的配置 **/
  // MetricsCreditability 指标置信度
  point00001: {
    newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
    newMarkType: NewMarkType.New,
  },
  // DataPrivacy 数据隐私
  point00002: {
    newMarkDisplayMode: NewMarkDisplayMode.RecordControlled,
    newMarkType: NewMarkType.New,
  },
  /** 小红点的配置 **/
};
